import styled from "@emotion/styled";
import { Grid, Typography } from "@mui/material";
import React from "react";

const HeadingGrid = styled(Grid)`
padding: ${props => props.p? props.p : '70px 0px 20px'};
`
const HeadingText = styled(Typography)`
    text-align: ${props => props.ta? props.ta : 'center'};
    color: #ffffff;
    font-family: poppins-bold;
    font-size: 2.8rem;
    @media (max-width: 700px){
        font-size: ${props => props.fs? props.fs : '3rem'};
        text-align: ${props => props.tas? props.tas : 'center'};
    }
`
const Heading = (props) => {
    const {title, discription} = props;
    return(
        <HeadingGrid xs={12} {...props} data-aos='zoom-in'>
            <HeadingText variant="h2" {...props}>{title}</HeadingText>
            <Typography variant="subtitle-1" sx={{color: '#ffffff', textAlign: 'center', margin: 'auto'}}>{discription}</Typography>
        </HeadingGrid>
    )
}
export default Heading;